import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import { GetCites } from '../../../store/actions/kalapost';
import { nextSecondSection, returnSection } from '../../../store/actions/order';
import {
   isAddress,
   isPersianWihsymbol,
   meliIdValidation,
   nationalIdValidation,
} from '../../../utils/persianLatter';
import {
   correctCharacters,
   isFullName,
   isNumber,
   isPhoneNumber,
} from '../../../utils/persianLatter';
import { canTypeForNumInput } from '../../../utils/numbers';
import { toEnglishNumbers } from '../../../utils/datePicker';

const ReceiverInfo = () => {
   const dispatch = useDispatch();
   const { section, fullName, phoneNumber, postalCode, address, states } = useSelector(
      (state) => state.order
   );

   const [force, forceUpdate] = useState(true);
   const [registerOrder, setRegisterOrder] = useState({
      name: fullName,
      phone: phoneNumber,
      postal: postalCode,
      des: '',
      stateId: '',
      cities: [],
      nationalId: null,
      receiverAddress: address,
   });

   const validator = useRef(
      new SimpleReactValidator({
         messages: {
            required: 'پر کردن این فیلد الزامی میباشد',
            min: 'کمتر از 2 حرف نمی تواند باشد',
         },
         validators: {
            phoneValid: {
               message: 'شماره موبایل صحیح نیست',
               rule: (val) => {
                  const numberStatus = isNumber(val);
                  const charStatus = numberStatus && correctCharacters(val);
                  const validPhone = isPhoneNumber(charStatus);
                  return validPhone;
               },
               required: true, // optional
            },
            postalValid: {
               message: 'کد پستی صحیح نیست',
               rule: (val) => {
                  const regpostalCode = new RegExp(`^([0-9]{10})$`);
                  return regpostalCode.test(val);
               },
               required: true, // optional
            },
            addressValid: {
               message: 'آدرس معتبر نیست',
               rule: (val) => {
                  return isAddress() && isPersianWihsymbol(val);
               },
               required: true,
            },
            nationalValid: {
               message: 'کد ملی صحیح نیست',
               rule: (val) => {
                  const meliId = meliIdValidation(val);
                  const nationalId = nationalIdValidation(val);
                  if (meliId && nationalId) {
                     return false;
                  } else {
                     return true;
                  }
               },
               required: true,
            },
            nameValid: {
               message: 'نام و نام خانوادگی معتبر نیست',
               rule: (val) => {
                  return isFullName(val);
               },
               required: true,
            },
         },
         element: (message) => <div style={{ color: 'red', fontSize: '1.3rem' }}>{message}</div>,
      })
   );

   const handleChange = (e) => {
      setRegisterOrder({
         ...registerOrder,
         [e.target.name]: toEnglishNumbers(e.target.value),
      });
      validator.current.showMessageFor(e.target.name);
   };
   const handleNext = () => {
      if (validator.current.allValid()) {
         dispatch(
            nextSecondSection(
               registerOrder.des,
               registerOrder.name,
               registerOrder.phone,
               registerOrder.postal,
               correctCharacters(registerOrder.receiverAddress),
               registerOrder.nationalId
            )
         );
      } else {
         validator.current.showMessages();
         forceUpdate(!force);
      }
   };
   const handleChangeState = async (e) => {
      const res = await GetCites(e.target.value);
      if (res.status) {
         setRegisterOrder((prev) => ({
            ...prev,
            cities: res.data,
            isState: true,
            stateId: e.target.value,
         }));
      } else {
         setRegisterOrder((prev) => ({ ...prev, stateId: e.target.value }));
      }
   };

   return (
      <div
         className={section === 2 ? 'progresstabs__content active-nav' : 'progresstabs__content'}
         style={{ minHeight: 'unset' }}
      >
         <h1 className='progresstabs__content-title'>مشخصات گیرنده</h1>
         <div className='progresstabs__content-receiver'>
            <div className='progresstabs__content-receiver-content'>
               <label className='progresstabs__content-receiver-label'>
                  نام و نام خانوادگی
                  <input
                     className='progresstabs__content-receiver-input'
                     type='text'
                     placeholder='نام و نام خانوادگی را وارد کنید'
                     name='name'
                     onChange={handleChange}
                     value={registerOrder.name || ''}
                  />
                  {validator.current.message('name', registerOrder.name, 'required|nameValid')}
               </label>
            </div>

            <div className='progresstabs__content-receiver-content'>
               <label className='progresstabs__content-receiver-label'>
                  کد ملی
                  <input
                     className='progresstabs__content-receiver-input'
                     type='text'
                     placeholder='کد ملی را وارد کنید'
                     name='nationalId'
                     value={registerOrder.nationalId || ''}
                     onChange={handleChange}
                     onKeyDown={canTypeForNumInput}
                  />
                  {validator.current.message(
                     'nationalId',
                     registerOrder.nationalId,
                     'required|nationalValid'
                  )}
               </label>
            </div>

            <div className='progresstabs__content-receiver-content'>
               <label className='progresstabs__content-receiver-label'>
                  شماره تماس
                  <input
                     type='text'
                     name='phone'
                     className='progresstabs__content-receiver-input'
                     placeholder='شماره تماس خود را وارد کنید'
                     value={registerOrder.phone || ''}
                     onChange={handleChange}
                     onKeyDown={canTypeForNumInput}
                  />
                  {validator.current.message('phone', registerOrder.phone, 'required|phoneValid')}
               </label>
            </div>

            <div className='progresstabs__content-receiver-content'>
               <label className='progresstabs__content-receiver-label'>
                  استان مقصد
                  <select
                     id='delivery'
                     className='progresstabs__content-receiver-input'
                     name='stateId'
                     onChange={handleChangeState}
                  >
                     <option hidden>انتخاب کنید ...</option>
                     {states.map((item) => (
                        <option key={item.stateId} value={item.stateId}>
                           {item.name}
                        </option>
                     ))}
                  </select>
                  {validator.current.message('stateId', registerOrder.stateId, 'required')}
               </label>
            </div>

            <div className='progresstabs__content-receiver-content'>
               <label className='progresstabs__content-receiver-label'>
                  شهر مقصد
                  <select
                     id='delivery'
                     className='progresstabs__content-receiver-input'
                     name='des'
                     value={registerOrder.des}
                     onChange={handleChange}
                     disabled={registerOrder.stateId === ''}
                  >
                     <option hidden>انتخاب کنید ...</option>
                     {registerOrder.cities.map((item) => (
                        <option key={item.id} value={item.id}>
                           {item.name}
                        </option>
                     ))}
                  </select>
                  {validator.current.message('des', registerOrder.des, 'required')}
               </label>
            </div>

            <div className='progresstabs__content-receiver-content'>
               <label className='progresstabs__content-receiver-label'>
                  کدپستی
                  <input
                     className='progresstabs__content-receiver-input'
                     type='text'
                     placeholder='کد پستی خود را وارد کنید'
                     name='postal'
                     value={registerOrder.postal || ''}
                     onChange={handleChange}
                     onKeyDown={canTypeForNumInput}
                  />
                  {validator.current.message(
                     'postal',
                     registerOrder.postal,
                     'required|postalValid'
                  )}
               </label>
            </div>

            <div className='progresstabs__content-receiver-content progresstabs__content-receiver-content--address'>
               <label className='progresstabs__content-receiver-label'>
                  آدرس
                  <textarea
                     className='progresstabs__content-receiver-input'
                     name='receiverAddress'
                     value={registerOrder.receiverAddress || ''}
                     onChange={handleChange}
                  />
                  {validator.current.message(
                     'receiverAddress',
                     registerOrder.receiverAddress,
                     'required|addressValid|min:2'
                  )}
               </label>
            </div>
         </div>
         <div className='progresstabs__content-buttons'>
            <button
               className='btn btn--secondary return-btn'
               onClick={() => dispatch(returnSection())}
            >
               بازگشت
            </button>
            <button className='btn btn--secondary next-btn' onClick={handleNext}>
               تایید و ادامه
            </button>
         </div>
      </div>
   );
};

export default ReceiverInfo;
